import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Content, Root as TooltipRoot, Trigger } from "@radix-ui/react-tooltip";
import Icon from "../../../../icons";
import { cn } from "../../../../utils";
import Button from "../../../Button";
const tooltipClassName = cn(
// animation
"data-[state=delayed-open]:animate-in data-[state=instant-open]:animate-none data-[state=delayed-open]:fade-in data-[state=delayed-open]:slide-in-from-bottom-4", 
// style
"rounded-md bg-black/90 px-2 py-0.5 text-sm font-medium text-white");
const buttonClassName = cn("hover:bg-white/20 disabled:bg-transparent disabled:opacity-30 text-white hover:text-white");
const ButtonHint = ({ label, children }) => {
    return (_jsxs(TooltipRoot, { children: [_jsx(Trigger, { asChild: true, children: _jsx("div", { children: children }) }), _jsx(Content, { className: tooltipClassName, side: "top", sideOffset: 25, children: label })] }));
};
const BasePlayerButton = ({ label, iconName, disabled, loading, onClick }) => {
    return (_jsx(ButtonHint, { label: label, children: _jsx(Button, { size: "md", onClick: onClick, icon: _jsx(Icon, { name: iconName, color: "white" }), variant: "text", className: buttonClassName, disabled: disabled, loading: loading }) }));
};
BasePlayerButton.displayName = "BasePlayerButton";
export default BasePlayerButton;
